import _ from 'lodash';
export const compareObjects = {
    compareTwoObjects: (obj1, obj2) => {
        let firstObject = _.cloneDeep(obj1);
        let secondObject = _.cloneDeep(obj2);
        Object.keys(secondObject).forEach((k) => {
            if(secondObject[k] == null || secondObject[k] == '' || secondObject[k] == undefined) {
                if(secondObject[k] !== false) {
                  delete secondObject[k]
                }
            }
        });
        Object.keys(firstObject).forEach((k) => {
            if(firstObject[k] == null || firstObject[k] == '' || firstObject[k] == undefined) {
                if(firstObject[k] !== false) {
                  delete firstObject[k]
                }
            }
        });

        return JSON.stringify(secondObject) === JSON.stringify(firstObject);
    }
}
